import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from 'env/environment';
import { AuthGuard } from './core/guard/auth.guard';
import { VnptpayComponent } from './modules/vnptpay/vnptpay.component';
import { AdminLayoutSidenavComponent } from './layouts/admin-layout-sidenav/admin-layout-sidenav.component';

const routes: Routes = [
  {
    path: 'trang-chu',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: '',
    component: AdminLayoutSidenavComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'nguoi-dung',
        loadChildren: () => import('modules/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'quan-tri-he-thong',
        loadChildren: () => import('src/app/modules/system/system.module').then((m) => m.SystemModule),
      },
      {
        path: 'tre-em',
        loadChildren: () => import('modules/treem/treem.module').then((m) => m.TreemModule),
      },
      {
        path: 'btxh-ho-ngheo',
        loadChildren: () => import('modules/btxh-ho-ngheo/btxh-ho-ngheo.module').then((m) => m.BtxhHoNgheoModule),
      },
      {
        path: 'mat-tran-to-quoc',
        loadChildren: () => import('modules/mat-tran-to-quoc/mat-tran-to-quoc.module').then((m) => m.MatTranToQuocModule),
      },
      {
        path: 'lao-dong-viec-lam',
        loadChildren: () => import('modules/viec-lam/viec-lam.module').then((m) => m.ViecLamModule)
      },
      {
        path: 'xuat-khau-lao-dong',
        loadChildren: () => import('modules/xuat-khau-lao-dong/xuat-khau-lao-dong.module').then((m) => m.XuatKhauLaoDongModule)
      },
      {
        path: 'bao-hiem-that-nghiep',
        loadChildren: () => import('modules/bao-hiem-that-nghiep/bao-hiem-that-nghiep.module').then((m) => m.BaoHiemThatNghiepModule)
      },
      {
        path: 'nguoi-co-cong',
        loadChildren: () => import('modules/nguoicocong/nguoicocong.module').then((m) => m.NguoicocongModule),
      },
      {
        path: 'gdnn',
        loadChildren: () => import('modules/gdnn/gdnn.module').then((m) => m.GdnnModule),
      },
      {
        path: 'gdnn-stg',
        loadChildren: () => import('modules/gdnn-stg/gdnn-stg.module').then((m) => m.GdnnStgModule),
      },
      {
        path: 'ma-tuy',
        loadChildren: () => import('modules/drug-addiction/drug-addiction.module').then((m) => m.DrugAddictionModule),
      },
      {
        path: 'binh-dang-gioi',
        loadChildren: () => import('modules/binh-dang-gioi/binh-dang-gioi.module').then((m) => m.BinhDangGioiModule)
      },
      {
        path: 'giam-ngheo-ben-vung',
        loadChildren: () => import('modules/giam-ngheo-ben-vung/giam-ngheo-ben-vung.module').then((m) => m.GiamNgheoBenVungModule)
      },
      {
        path: 'cac-hoi',
        loadChildren: () => import('modules/cac-hoi/cac-hoi.module').then((m) => m.CacHoiModule)
      },
      {
        path: 'thanh-tra',
        loadChildren: () => import('modules/thanhtra/thanhtra.module').then((m) => m.ThanhtraModule)
      },
      {
        path: 'van-phong',
        loadChildren: () => import('modules/van-phong/van-phong.module').then((m) => m.VanPhongModule)
      },
      {
        path: 'ke-hoach-tai-chinh',
        loadChildren: () => import('modules/ke-hoach-tai-chinh/khtc.module').then((m) => m.KhtcModule)
      },
      {
        path: 'baocao-gdnn',
        loadChildren: () => import('modules/baocao-gdnn/baocao-gdnn.module').then((m) => m.BaocaoGdnnModule),
      },
      {
        path: 'binh-dang-gioi',
        loadChildren: () => import('modules/binh-dang-gioi/binh-dang-gioi.module').then((m) => m.BinhDangGioiModule)
      },
      {
        path: 'thanh-tra',
        loadChildren: () => import('modules/thanhtra/thanhtra.module').then((m) => m.ThanhtraModule)
      },
      {
        path: 'van-phong',
        loadChildren: () => import('modules/van-phong/van-phong.module').then((m) => m.VanPhongModule)
      },
      {
        path: 'ke-hoach-tai-chinh',
        loadChildren: () => import('modules/ke-hoach-tai-chinh/khtc.module').then((m) => m.KhtcModule)
      },
      {
        path: 'ioc',
        loadChildren: () => import('modules/ioc/ioc.module').then((m) => m.IocModule)
      },
      {
        path: 'ho-trung-binh',
        loadChildren: () => import('modules/ho-trung-binh/ho-trung-binh.module').then((m) => m.HoTrungBinhModule)
      },
      {
        path: 'ho-trung-binh-new',
        loadChildren: () => import('modules/ho-trung-binh-new/ho-trung-binh-new.module').then((m) => m.HoTrungBinhModule)
      },
      {
        path: 'bao-cao-tong-hop',
        loadChildren: () => import('src/app/modules/bao-cao-tong-hop/bao-cao-tong-hop.module').then((m) => m.BaoCaoTongHopModule)
      }
    ]
  },
  {
    path: 'error',
    loadChildren: () =>
      import('modules/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: 'dang-nhap',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'vnptpay',
    component: VnptpayComponent
  },
  {
    path: '**',
    redirectTo: 'error/page-not-found',
  },
];

// if (environment.defaultRouterLink) {
//   routes.unshift({
//     path: '',
//     redirectTo: environment.defaultRouterLink,
//     pathMatch: 'full',
//   });
// }

@NgModule({
  imports: [RouterModule.forRoot(routes, environment.routerConfig)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
